import React, { useState } from "react";

import { ActionsMenu, MenuItem, ActionItem, BasicActionsMenuProps } from "ui/actions-menu";

import Icons from "assets";

interface ActionsMenuProps extends BasicActionsMenuProps {
  onView: (id: string) => void;
  onSendForReview: (id: string) => void;
  onDelete: (id: string) => void;
}

const ApprovalQueueTableActionsMenu: React.FC<ActionsMenuProps> = ({
  item,
  onView,
  onSendForReview,
  onDelete,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleMenuOpen = () => setIsOpen(true);
  const handleMenuClose = () => setIsOpen(false);

  const actionItems: ActionItem[] = [
    {
      icon: <Icons.Document className="text-gray-600 size-5" />,
      label: "View batch details",
      onClick: (id: string) => {
        onView(id);
      },
    },
    ...(item.isSendToClientShown
      ? [
          {
            icon: <Icons.Airplane className="text-gray-600 size-5" />,
            label: "Send for review",
            onClick: (id: string) => {
              onSendForReview(id);
            },
          },
        ]
      : []),
    {
      icon: <Icons.Trash className="text-gray-600 size-5" />,
      label: "Delete batch",
      onClick: (id: string) => {
        onDelete(id);
      },
    },
  ];

  return (
    <ActionsMenu itemName={item.itemName} open={isOpen} onOpen={handleMenuOpen} onClose={handleMenuClose}>
      {actionItems.map((actionItem) => (
        <MenuItem
          key={actionItem.label}
          icon={actionItem.icon}
          label={actionItem.label}
          onClick={() => {
            actionItem.onClick(item.itemId);
            setIsOpen(false);
          }}
        />
      ))}
    </ActionsMenu>
  );
};

export default ApprovalQueueTableActionsMenu;
